import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      data-testid="hero-section" 
      className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden noise-bg"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1575281605588-a6f284292268?q=80&w=2070&auto=format&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/60 to-[#050505] z-10" />
      
      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-6xl mx-auto">
        {/* Main Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter uppercase mb-6"
        >
          <span className="text-gradient">GET SLUSH'D</span>
        </motion.h1>
        
        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-6 font-light"
        >
          100% juice-based slushies enriched with vitamins and electrolytes. 
          Keep your festival crowd hydrated and energized all day long.
        </motion.p>
        
        {/* Health Badges */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="flex flex-wrap justify-center gap-3 mb-10"
        >
          {['No Added Sugar', 'Vegan', 'Gluten Free', 'Vitamin Enriched', 'Kid Friendly'].map((badge) => (
            <span 
              key={badge}
              className="px-4 py-1.5 rounded-full text-xs font-medium uppercase tracking-wider bg-white/10 text-white/90 border border-white/20"
            >
              {badge}
            </span>
          ))}
        </motion.div>
        
        {/* CTA Button */}
        <motion.button
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToContact}
          data-testid="hero-cta-btn"
          className="bg-[#CCFF00] text-black font-bold text-lg md:text-xl px-10 py-4 rounded-full neon-glow-hover transition-all duration-300 uppercase tracking-wider"
        >
          Book Us Now
        </motion.button>
      </div>
      
      {/* Marquee */}
      <div className="absolute bottom-20 left-0 right-0 z-20 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap flex">
          {[...Array(4)].map((_, i) => (
            <span key={i} className="text-[#CCFF00]/20 text-4xl md:text-6xl font-black uppercase tracking-widest mx-8">
              SLUSH'D • FESTIVALS • EVENTS • PARTIES • ICE COLD • 
            </span>
          ))}
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{ duration: 1.5, delay: 1, repeat: Infinity }}
        className="absolute bottom-8 z-20"
      >
        <ChevronDown className="w-8 h-8 text-white/50" />
      </motion.div>
    </section>
  );
};

export default HeroSection;
